import Progress from "./components/Progress";
import Ranking from "./components/Ranking";
import Awards from "./components/Awards";

import "./styles.scss";

export default function Gamification({ groupInfo, groupId }) {
    return (
        <div className="gamification-box">
            <Progress interval={groupInfo?.interval} />
            <Ranking groupId={groupId} />
            <Awards awards={groupInfo?.awards} />
        </div>
    );
}
